<div *ngIf="document">
  <div class="fx-row align-items-center justify-content-between p-16">
    <div class="fx-column fx-flex">
      <span class="title bold">
        {{'DOCUMENT.EDIT_REDACTS' | translate}}
      </span>
      <span class="small light">{{document.name}}</span>
    </div>
    <mat-icon class="ml-20 dark clickable" fontSet="material-icons-outlined" (click)="onClose()">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div class="p-16">
    <mat-slide-toggle color="main" (change)="onToggleShowEvidencesWithRedacts.emit($event.checked)"
      [checked]="showEvidencesWithRedacts">
      {{"DOCUMENT.EVIDENCE_TOGGLE_MODE"|translate}}
    </mat-slide-toggle>
  </div>
  <div class="p-16">
    <mat-divider></mat-divider>
    <mat-card class="annotation-instructions">
      <div class="fx-column">
        <span class="text main bold">{{'DOCUMENT.REDACT_ADD_TITLE' | translate}}</span>
        <span class="text dark">{{'DOCUMENT.REDACT_ADD_DESCRIPTION' | translate}}</span>
        <div class="fx-row align-items-center justify-content-start mt-10">
          <mat-slide-toggle color="main" (change)="onToggleDraw()" [checked]="isDraw">
            {{"DOCUMENT.REDACT_ADD_TOGGLE"|translate}}
          </mat-slide-toggle>
        </div>
        <mat-divider class="mv-10" *ngIf="isDraw && drawing"></mat-divider>
        <div class="fx-column" *ngIf="isDraw && drawing">
          <span class="small light">{{'DOCUMENT.REDACT_ADD_HINT' | translate}}</span>
          <div class="fx-column align-items-start justify-content-start mt-10">
            <div class="fx-row align-items-center justify-content-start mt-10">
              <button class="button" (click)="onCancelAnnotation()" [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="'DOCUMENT.CANCEL_ANNOTATION' | translate">
                {{'ACTIONS.CANCEL' | translate}}
              </button>
              <button class="main-button ml-10" (click)="onConfirmRedact()" [matTooltipClass]="{'uzai-tooltip':true}"
                [matTooltip]="'DOCUMENT.CONFIRM_ANNOTATION' | translate">
                {{'ACTIONS.VALIDATE' | translate}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <mat-divider></mat-divider>
  <div class="p-16">
    <span class="text main bold">{{'ENTITIES.REDACTIONS' | translate}}</span>
    <div class="p-16 fx-column">
      <div class="fx-row align-items-center justify-content-between">
        <div class="fx-column">
          <span class="text light" *ngIf="redacts.length === 0">{{'DOCUMENT.REDACT_LIST_EMPTY' | translate}}</span>
          <span class="text light" *ngIf="redacts.length > 0">{{'DOCUMENT.REDACT_LIST_HINT' | translate}}</span>
        </div>
      </div>
      <div class="mt-5 fx-row fx-wrap align-items-center justify-content-start">
        <div class="fx-column fx-flex-100" *ngFor="let redact of redacts; let redactIndex = index">
          <div class="redactItem fx-row align-items-center justify-content-start metadata border-box fx-flex-100"
            (mouseenter)="onMouseEnter(redact._id)" (mouseleave)="onMouseLeave(redact._id)"
            [class.highlighted]="currentHighlight?.value?._id === redact._id">
            <div class="fx-flex-60 fx-wrap align-items-center justify-content-start">
              <span class="text">{{'ENTITIES.REDACTION' | translate}} n°{{redactIndex+1}}</span>
            </div>
            <div class="fx-row align-items-center justify-content-start fx-flex-30">
              <span class="small light">{{'DOCUMENT.MANUAL_PROOF' | translate}}</span>
            </div>
            <div class="icons fx-row align-items-center justify-content-end fx-flex-10">
              <mat-icon class="red clickable" fontSet="material-icons-outlined"
                [matTooltipClass]="{'uzai-tooltip':true}" [matTooltip]="'DOCUMENT.REDACT_DELETE_TOOLTIP' | translate"
                (click)="delete.emit(redact)">remove_circle_outline</mat-icon>
            </div>
          </div>
        </div>
      </div>
    </div>
    <mat-divider></mat-divider>
  </div>
</div>